import AdditionalInfoSearchDialog from "./additionalInfoSearchDialog.container";

export default AdditionalInfoSearchDialog;